module.exports = __webpack_public_path__ + "553a1d783662ec21ffc8c9b7a4a60e89.svg";